// App-wide config (routes, env vars) goes here.

export const IS_PRODUCTION = (process.env.NODE_ENV === 'production')

const getPositiveIntegerEnv = (value, fallback) => {
  const integer = parseInt(value, 10)
  return integer > 0 ? integer : fallback
}

//Acivity Types
export const SPORT_ACTIVITY = 'Sport'

export const DYNAMIC_PRICE_REMAINING_TICKET_THRESHOLD = getPositiveIntegerEnv(
  process.env.DYNAMIC_PRICE_REMAINING_TICKET_THRESHOLD,
  30
)

export const CALENDAR_DATE_REMAINING_TICKET_THRESHOLD = getPositiveIntegerEnv(
  process.env.CALENDAR_DATE_REMAINING_TICKET_THRESHOLD,
  30
)

// Memberships
export const NEW_MEMBERSHIP_ID = 'new'

export const PROTECTED_EDIT_MODE_ROUTES = [
  /\/activities\/\d+(\?.*&)?\borderToken=[^&]+/,
  /\/orders\/\d+/,
  /\/activities\/payment(\?.*(&|\\?)orderToken=[^&]+.*)?/,
  /\/orders\/confirmation\/[^/]+/
]
